export enum DoorHingeBackset {
  _316 = '3/16"',
  _14 = '1/4"',
}
